/**
 * Paths that must never trigger a hard redirect to /login on 401,
 * and should not send a stale Bearer token (invite + auth bootstrap).
 */
export function isPublicApiPath(url) {
  if (!url || typeof url !== 'string') return false;
  const u = url.split('?')[0];
  return (
    u.includes('tenant-invite/verify')
    || u.includes('tenant-invite/activate')
    || u.includes('auth/login')
    || u.includes('auth/register')
    || u.includes('auth/refresh')
    || u.includes('auth/forgot-password')
    || u.includes('auth/reset-password')
    || u.includes('auth/verify-email')
    || u.includes('exchange-rates')
    || u.includes('billing/tiers')
    || u.includes('billing/status')
  );
}

export function isAuthMePath(url) {
  if (!url || typeof url !== 'string') return false;
  return url.split('?')[0].includes('auth/me');
}

function normalizePathname(pathname) {
  if (!pathname || typeof pathname !== 'string') return '';
  const base = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  return base;
}

/** Invite / reset flows must not bootstrap or reuse a stale session. */
export function isAnonymousAuthFlowRoute(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  const p = normalizePathname(pathname);
  return (
    p === '/tenant-setup'
    || p === '/reset-password'
    || p === '/forgot-password'
    || p === '/verify-email'
  );
}

/** SPA routes where a 401 should clear session but not hard-redirect (user may be onboarding). */
export function isPublicAppRoute(pathname = typeof window !== 'undefined' ? window.location.pathname : '') {
  const p = normalizePathname(pathname);
  return (
    p === '/login'
    || p === '/register'
    || p === '/tenant-setup'
    || p === '/forgot-password'
    || p === '/reset-password'
    || p === '/verify-email'
    || p === '/'
    || p === '/pricing'
  );
}

/** Clear stale credentials before password-reset / invite API calls. */
export function clearStoredSession() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  } catch {
    /* ignore */
  }
}
